export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8228.45f4e795.jpg";